import React from 'react';
import { CheckCircle } from 'lucide-react';

const SuccessMessage: React.FC = () => {
  return (
    <div className="success-container">
      <CheckCircle size={64} className="success-icon" />
      <h2>Account Successfully Deleted</h2>
      <p>Your account and all associated data have been permanently deleted from our system.</p>
      
      <div className="additional-info">
        <p>What happens next?</p>
        <ul>
          {/* <li>You'll receive a confirmation email that your account has been deleted</li> */}
          <li>Any active sessions will be terminated</li>
          <li>Your data will be removed from our systems within 24 hours</li>
        </ul>
      </div>

      <a href="/" className="home-link">Return to Home Page</a>
    </div>
  );
};

export default SuccessMessage;